/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <!-- <form @submit.stop.prevent="handleSubmit" novalidate class="text-left"> -->
  <form novalidate class="text-left" :class="[isValidForm ? 'is-valid-form' : 'is-invalid-form']">
    <!-- use shipping -->
    <b-form-group id="groupUseOtherAddress" v-if="useOtherAddressLabel">
      <base-check-box
        :name="name + '-useotheraddress'"
        v-model="address.useotheraddress"
        :label="useOtherAddressLabel"
      />
    </b-form-group>

    <section v-show="showAddress" :key="name">
      <address-autocomplete
        :name="name"
        ref="addressAutocomplete"
        :use-email="useEmail"
        :email="email"
        @update:email="$emit('update:email', $event)"
        :address="address"
        @changeCountry="$emit('changeCountry', $event)"
        />
    </section>

    <button v-if="showSubmitButton" type="button" class="btn btn-primary" :disabled="!isValidForm" :block="true" @click="handleSubmit">{{$t('Continue')}}</button>
  </form>
</template>

<script>
import AddressAutocomplete from 'theme/components/Form/AddressAutocomplete'
import BaseCheckBox from 'theme/components/Form/BaseCheckBox'
import BaseInput from 'theme/components/Form/BaseInput'
import some from 'lodash/some'
import sortBy from 'lodash/sortBy'

export default {
  name: 'GenericAddressForm',
  props: {
    value: {
      type: Boolean,
      default: () => false
    },
    name: {
      type: String,
      default: () => 'generic-address'
    },
    address: {
      type: Object,
      required: true
    },
    isBilling: {
      type: Boolean,
      default: () => false
    },
    showSubmitButton: {
      type: Boolean,
      default: () => true
    },
    useOtherAddressLabel: {
      type: String,
      default: ''
    },
    useEmail: {
      type: Boolean,
      default: false
    },
    email: {
      type: String,
      default: ''
    },
    useAddressForm: {
      type: Boolean,
      default: false
    }
  },
  $_veeValidate: {
    validator: 'new',
    value () {
      return this.isValidForm
    },
    name () {
      return this.name
    }
  },
  data () {
    return {
      isInvoiceDisabled: false,
      isInvoiceRequired: false
    }
  },
  methods: {
    invoiceManager () {
      // @see https://bcame.atlassian.net/browse/NES-101
      // for more info
      if (this.isBilling) {
        let isEnableByAddress = !!this.address.vat_id
        let isEnableByRequestInvoice = this.requiredReqInvoice
        this.isInvoiceRequired = (isEnableByAddress || isEnableByRequestInvoice)
        this.isInvoiceDisabled = (isEnableByRequestInvoice)
        this.address.vat_id = this.address.vat_id || ''
      }
    },
    handleSubmit () {
      const self = this
      const newAddress = { ...self.address }
      return this.$validator.validateAll().then(isValid => {
        if (isValid) {
          if (self.isBilling) {
            if (!self.requireInvoice) {
              newAddress.vat_id = ''
            }
          }
          self.$emit('submit', newAddress)
          return true
        } else {
          let orderError = sortBy(self.$validator.errors.items, item => parseInt(item.id))
          if (orderError.length) {
            const _el = self.$el.querySelector(`[name="${orderError[0].field}"]`)
            if (_el) {
              self.$nextTick(() => {
                _el.focus()
                _el.scrollIntoView({ behavior: 'smooth', block: 'center' })
              })
            }
          }
        }
        return false
      })
    },
    changeAddress () {
      this.init()
    },
    init () {
      this.invoiceManager()
    }
  },
  watch: {
    isValidForm (val) {
      // used for validation parents
      this.$emit('input', val)
    }
  },
  computed: {
    enableReqInvoice () {
      return this.$store.state.storeConfig.config ? this.$store.state.storeConfig.config.requestInvoiceSettings.is_enabled : false
    },
    requiredReqInvoice () {
      return this.$store.getters['checkout/needInvoice']
    },
    showAddress () {
      if (this.address.useotheraddress) {
        return false
      }
      return this.useAddressForm
    },
    isValidForm () {
      return !some(this.veeFields, { invalid: true })
    }
  },
  mounted () {
    this.$emit('input', this.isValidForm)
    this.init()
  },
  components: {
    AddressAutocomplete,
    BaseCheckBox,
    BaseInput
  }
}
</script>
